import axios from 'axios';
import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { IoMdArrowRoundBack } from "react-icons/io";

function CategoryListPage() {
    const [catList, setCatList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3500';

    // Tiny transparent gif fallback (same used elsewhere) + dim to signal fallback
    const imgFallback = 'data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=';
    const handleImgError = (e) => {
        if (!e.currentTarget.dataset.fallback) {
            e.currentTarget.dataset.fallback = '1';
            e.currentTarget.src = imgFallback;
            e.currentTarget.style.opacity = '0.5';
        }
    };

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                setError(null);
                const response = await axios.get(`${API_URL}/categorydata`);
                setCatList(response.data || []);
            } catch (err) {
                console.error("Error fetching categories:", err);
                setError('Failed to load categories');
            } finally {
                setLoading(false);
            }
        };
        fetchCategories();
    }, [API_URL]); // Ensures re-fetch when API URL changes

    return (
        <Fragment>
            <div className="container-fluid m-t25">
                {error && (
                    <div className="alert alert-warning small rounded-0 mt-2 mb-0" role="alert">
                        {error}
                    </div>
                )}
                <div className="row">
                    <div className="col-12 cat-strip border shadow-sm">
                        <div>
                            <button onClick={() => window.history.back()} aria-label="Go Back">
                                <IoMdArrowRoundBack />
                            </button>
                            <label>ALL CATEGORIES</label>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {loading ? (
                        <div className="loading-spinner">
                            <div className="spinner-border text-danger" role="status">
                                <span className="visually-hidden">Loading categories...</span>
                            </div>
                        </div>
                    ) : (
                        catList.length > 0 ? (
                            catList.map((item, index) => (
                                <div className="col-lg-2 col-md-3 col-sm-4 col-6 clist border text-center" key={item._id || index}>
                                    <Link to={`/products-by-cat/${item.name}`} className="d-block w-100" aria-label={`View category ${item.name}`} title={item.name}>
                                        <img src={`${API_URL}/${item.image}`} className="img-fluid" alt={item.name} onError={handleImgError} loading="lazy" />
                                        <label>{item.name.toUpperCase()}</label>
                                    </Link>
                                </div>
                            ))
                        ) : (
                            <p className="text-center">No categories available.</p>
                        )
                    )}
                </div>
            </div>
        </Fragment>
    );
}

export default CategoryListPage;
